import { Logo } from './Logo';
import { ChatHistoryItem } from './ChatHistoryItem';

export const Sidebar = ({ isSidebarOpen, chatHistory, getChatMessages }) => {

  return (<aside className={`w-[280px] flex-shrink-0 flex-col h-full px-5 py-8 overflow-y-auto hide-scrollbar transition-all duration-300 bg-[#e8edf3] dark:bg-[#0f172a] z-10 ${isSidebarOpen ? 'flex' : 'hidden'}`}>
    <Logo />
    <div className="mb-8">
      <h3 className="text-sm font-bold text-slate-800 dark:text-slate-200 mb-4 uppercase tracking-wider">Recent Conversation</h3>
      <div className="rounded-2xl bg-white/60 dark:bg-slate-800/60 backdrop-blur-xl p-3 shadow-sm border border-white/80 dark:border-slate-700/50">
        <div className="space-y-0.5">
          {[...chatHistory].sort((a, b) => (b.pinned === a.pinned ? 0 : a.pinned ? -1 : 1)).map(chat => (
            <ChatHistoryItem key={chat.conversationId || chat.ConversationId} onClick={() => getChatMessages(chat.conversationId || chat.ConversationId)} chat={chat} />
          ))}
        </div>
      </div>
    </div>
  </aside>)
};
